import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { bool, func, object, string } from 'prop-types';
import FieldTextInput from '../../../../components/FieldTextInput/FieldTextInput';
import css from './EditListingPricingForm.module.css';
import { FieldCurrencyInput, FieldQuantityInput, FieldSelect } from '../../../../components';
import { createSlug } from '../../../../util/urlHelpers';
import { FormattedMessage } from '../../../../util/reactIntl';

const durationArray = [
  { value: '2 hours', label: 'Two hours' },
  { value: '3 hours', label: 'Three hours' },
  { value: '4 hours', label: 'Four hours' },
];

const DurationFieldArray = props => {
  const {
    push,
    pop,
    removeButtonText,
    addButtonText,
    arrayName,
    optionFieldLabel,
    optionFieldPlaceHolder,
    priceFieldLabel,
    priceFieldPlaceHolder,
    currencyConfig,
    isOptions,
    descriptionFieldLabel,
    descriptionFieldPlaceHolder,
    descriptionValidators,
    intl,
    minDuration,
    durationValidators,
    formValues
  } = props;

  const priceValidators = !isOptions ? props.priceValidators : null;

  return (
    <div>
      <FieldArray name={arrayName}>
        {({ fields }) => {
          return fields.map((name, index) => (
            <div key={name} className={css.itemWrapper}>
              <div className={css.itemContainer}>
                <FieldTextInput
                  className={css.optionInput}
                  type="number"
                  id={`${name}.duration`}
                  name={`${name}.duration`}
                  label={optionFieldLabel}
                  placeholder={optionFieldPlaceHolder}
                  max={minDuration}
                  validate={value => durationValidators(value, 0, minDuration, intl)}
                />

                {/*<FieldQuantityInput*/}
                {/*  id={`${name}.duration`}*/}
                {/*  name={`${name}.duration`}*/}
                {/*  type="number"*/}
                {/*  min={1}*/}
                {/*  max={1000000}*/}
                {/*  initialValue={1}*/}
                {/*  className={css.field}*/}
                {/*/>*/}

                {/*<FieldSelect*/}
                {/*  id={`${name}.duration1`}*/}
                {/*  name={`${name}.duration1`}*/}
                {/*  className={css.optionInput}*/}
                {/*  label={optionFieldLabel}*/}
                {/*  placeholder={optionFieldPlaceHolder}*/}
                {/*  validate={durationValidators}*/}
                {/*>*/}
                {/*  <option disabled value="" key="unselected">*/}
                {/*    {intl.formatMessage({ id: 'PriceVariantPicker.priceVariantUnselected' })}*/}
                {/*  </option>*/}
                {/*  {durationArray.map(pv => (*/}
                {/*    <option value={pv.label} key={pv.name}>*/}
                {/*      {pv.label}*/}
                {/*    </option>*/}
                {/*  ))}*/}
                {/*</FieldSelect>*/}

                <FieldCurrencyInput
                  id={`${name}.price`}
                  name={`${name}.price`}
                  className={css.input}
                  label={priceFieldLabel}
                  placeholder={priceFieldPlaceHolder}
                  currencyConfig={currencyConfig}
                  validate={priceValidators}
                />

                {/*{index === 0 && (*/}
                {/*  <button type="button" className={css.removeOptionFirst}>*/}
                {/*    {removeButtonText}*/}
                {/*  </button>*/}
                {/*)}*/}

                {/*{index !== 0 && (*/}
                {/*  <button*/}
                {/*    type="button"*/}
                {/*    className={css.removeOption}*/}
                {/*    onClick={() => {*/}
                {/*      console.log(fields, 'fields')*/}
                {/*      console.log(name, 'name')*/}
                {/*      return fields.pop(arrayName, index);*/}
                {/*    }}*/}
                {/*  >*/}
                {/*    {removeButtonText}*/}
                {/*  </button>*/}
                {/*)}*/}
              </div>
              <div className={css.itemContainer}>
                <FieldTextInput
                  className={css.descriptionInput}
                  type="textarea"
                  id={`${name}.description`}
                  name={`${name}.description`}
                  label={descriptionFieldLabel}
                  placeholder={descriptionFieldPlaceHolder}
                  validate={descriptionValidators}
                />
              </div>
            </div>
          ));
        }}
      </FieldArray>


      <div className={css.buttons}>
        <button type="button" onClick={() => push(arrayName, undefined)} className={css.addOption}>
          {addButtonText}
        </button>
        {formValues?.optionDuration && formValues?.optionDuration?.length > 1 &&
          (<button type="button" onClick={() => pop(arrayName)} className={css.removeOption}>
            {removeButtonText}
          </button>)
        }
      </div>
    </div>
  );
};

DurationFieldArray.propTypes = {
  rootClassName: string,
  className: string,
  inputRootClass: string,

  onUnmount: func,

  // Error message that can be manually passed to input field,
  // overrides default validation message
  customErrorText: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string,
  label: string,

  // Uncontrolled input uses defaultValue prop, but doesn't pass value from form to the field.
  // https://reactjs.org/docs/uncontrolled-components.html#default-values
  isUncontrolled: bool,
  // a ref object passed for input element.
  inputRef: object,
};

export default DurationFieldArray;
